module.exports = __webpack_public_path__ + "static/media/c.4b297e20.gif";